/* @flow */

import * as types from './uiNotificationActionTypes';

import type { Notification } from 'src/shared/app/notification/type/notificationTypes';

export function queueNotification(notification: Notification) {
  return {
    type: types.QUEUE_NOTIFICATION,
    notification,
  };
}

export function dismissNotification(notification: string | Notification) {
  return {
    type: types.DISMISS_NOTIFICATION,
    notification,
  };
}
